<!-- Header Structure -->
<template>
  <div>
    <v-navigation-drawer v-if="!horizontal" app fixed v-model="drawer" mini-variant-width="70" :width="250" class="Vuely-sidebar">
      <!-- App Sidebar -->
      <app-sidebar></app-sidebar>
    </v-navigation-drawer>
    <v-toolbar class="Vuely-toolbar" height="50" app fixed>
      <div class="d-custom-flex align-items-center navbar-left">
        <div v-if="!horizontal">
          <v-toolbar-side-icon icon large @click.stop="drawer = !drawer" class="v-step-0"></v-toolbar-side-icon>
        </div>
      </div>
      <div class="navbar-right">
        <v-layout row wrap v-if="userProfile">
          <v-flex v-if="userProfile.notification" xs1 sm1 md1 lg1 xl1 class="text-xs-right">
            <notifications-badge></notifications-badge>
          </v-flex>
          <v-flex xs8 sm7 md7 lg7 xl7 class="text-xs-right">
            <company ></company>
          </v-flex>
          <v-flex xs2 hidden-xs-only>
            <v-layout align-center justify-center row fill-height>
              <v-flex xs6>
                <v-icon color="primary">schedule</v-icon>
              </v-flex>
              <v-flex xs6>
                <span slot="default" class="text-secondary ml-1">{{nzDateHour(date)}}</span>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs2 sm2 md2 lg2 xl2 class="text-lg-right">
            <div>
              <user-block></user-block>
            </div>
          </v-flex>
        </v-layout>
      </div>
    </v-toolbar>
  </div>
</template>
<script>
import Sidebar from "../Sidebar/Sidebar.vue";
import UserBlock from "./UserBlock";
import NotificationsBadge from "./NotificationsBadge";

import Company from "./Company";
import { getCurrentAppLayout } from "@/common/helpers/helpers";
import { nzDateHour } from "@/common/helpers/helpers";
import { mapGetters } from "vuex";
import Vue from "vue";

export default {
  props: {
    horizontal: {
      default: false,
      type: Boolean
    }
  },
  data() {
    return {
      date: new Date(),
      timer: "",
      drawer: true // sidebar drawer default true
    };
  },
  mounted() {
    this.refreshDate();
    this.timer = setInterval(this.refreshDate, 30000);
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  computed: {
    ...mapGetters(["userProfile"])
  },
  methods: {
    nzDateHour: nzDateHour,
    refreshDate() {
      this.date = new Date();
    }
  },
  components: {
    NotificationsBadge,
    Company,
    UserBlock,
    appSidebar: Sidebar
  }
};
</script>
